import { notEmpty } from "shared/lib/utils";

import { StaticSourceUrl, VideoSource } from "./enums";

export const isScmpYoutubeVideo = (
  attributes:
    | undefined
    | {
        "data-video-source"?: string;
        "data-youtube-id"?: string;
      },
) =>
  attributes?.["data-video-source"] === VideoSource.SCMP &&
  notEmpty(attributes?.["data-youtube-id"]);

export const isDataWrapper = (source: string) => source.includes(StaticSourceUrl.DataWrapper);

export const isSCMPMultimedia = (source: string) => source.includes(StaticSourceUrl.SCMPMultimedia);

export const checkSchemaNodeHasScmpYoutubeVideo = (node: SchemaNode) => {
  if (!node) return false;
  const checkIsScmpYoutubeVideo = (node: SchemaNode): boolean => {
    if (node?.children && node?.children.length > 0)
      return node.children?.some(n => checkIsScmpYoutubeVideo(n));
    return isScmpYoutubeVideo(node.attribs);
  };
  return checkIsScmpYoutubeVideo(node);
};

export const getDimensionWithUnit = (
  dimension?: number | string,
  defaultValue: string = "auto",
) => {
  if (!notEmpty(dimension)) return defaultValue;
  if (typeof dimension === "string") {
    if (dimension.endsWith("%")) return dimension;
    if (dimension.endsWith("px")) return dimension;
    dimension = Number.parseFloat(dimension);
  }
  return `${dimension}px`;
};

export const getYoutubeIdFromUrl = (source: string) => {
  /* cspell:disable-next-line */
  const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = source.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};
